const header = {
  // all the properties are optional - can be left empty or deleted
  homepage: 'https://rjshkhr.github.io/cleanfolio',
  title: '@shazy',
}

const about = {
  // all the properties are optional - can be left empty or deleted
  name: 'Eugene Shatskih',
  role: 'Web Developer',
  description:
    'I’m passionate about building responsive, user-friendly websites that look great and perform even better. Whether it’s crafting custom themes or collaborating on bigger projects, I focus on creating solutions that fit client needs perfectly. Over the years, I’ve worked on a mix of corporate and freelance projects, always aiming to deliver websites that are easy to manage and a joy to use.',
  resume: '/Eugene-Shatskih-WordPress--Frontend-developer-CV.pdf',
  social: {
    linkedin: 'https://www.linkedin.com/in/eugeneshatskih/',
    mail: 'eugene.shatskih@gmail.com',
    github: '',
    upwork: 'https://www.upwork.com/freelancers/eugeneshatskih',
  },
}

const skills = [
  // skills can be added or removed
  // if there are no skills, Skills section won't show up
  'HTML',
  'CSS',
  'SASS/SCSS',
  'Tailwind CSS',
  'Bootstrap',
  'Foundation',
  'JavaScript',
  'jQuery',
  'React',
  'React Native',
  'WordPress',
  'ACF Pro',
  'Gutenberg',
  'Elementor Pro',
  'PHP',
  'MySQL',
  'Git',
  'npm',
  'gulp',
]

const projects = [
  // projects can be added an removed
  // if there are no projects, Projects section won't show up
  {
    name: 'Nave',
    titleColorLight: '#004c96',
    titleColorDark: '#8cbde8',
    description:
      'Kanban Dashboards Startup. Stattic website + WordPress blog',
    image: 'images/nave.jpg',
    stack: [ 'Bootstrap', 'SASS/SCSS', 'WordPress', 'Tailwind CSS', 'JavaScript', 'jQuery', 'PHP' ],
    sourceCode: '',
    livePreview: 'http://getnave.com',
  },
  {
    name: 'RevSeller',
    titleColorLight: '#4B8434',
    titleColorDark: '#8ecc71',
    description:
      'React Native iOS and Android apps + Chrome extension',
    image: 'images/revseller.png',
    stack: [ 'React', 'React Native', 'Tailwind CSS', 'JavaScript' ],
    sourceCode: '',
    livePreview: '',
  },
  {
    name: 'Phocus',
    titleColorLight: '#3c1478',
    titleColorDark: '#a59aff',
    description: 'HR & Payroll website',
    image: 'images/phocus.jpg',
    stack: [ 'WordPress', 'Gutenberg', 'ACF', 'Tailwind CSS', 'SASS/SCSS', 'JavaScript', 'PHP' ],
    sourceCode: 'https://github.com',
    livePreview: 'https://phocus.nl/',
  },
  {
    name: 'Bruton Lloyd',
    titleColorLight: '#6b0100',
    titleColorDark: '#ffecb3',
    description: 'Educational Consultants website',
    image: 'images/bruton-lloyd.jpg',
    stack: [ 'WordPress', 'Bootstrap', 'SASS/SCSS', 'JavaScript', 'jQuery', 'PHP', 'ACF', 'Multi-language' ],
    sourceCode: '',
    livePreview: 'https://www.brutonlloyd.com',
  },
  {
    name: 'AP-Feuerwerk',
    titleColorLight: '#ff2834',
    titleColorDark: '#ff666f',
    description:
      'Pyrotechnics store on WordPress',
    image: 'images/ap-feuerwerk.jpg',
    stack: [ 'WordPress', 'Gutenberg', 'ACF', 'Tailwind CSS', 'SASS/SCSS', 'JavaScript', 'PHP', 'API integration' ],
    sourceCode: '',
    livePreview: 'https://ap-feuerwerk.de/',
  },
  {
    name: 'Wiilo',
    titleColorLight: '#081e27',
    titleColorDark: '#a0e0e7',
    image: 'images/wiilo.jpg',
    description:
      'Logistic company website',
    stack: [ 'WordPress', 'Gutenberg', 'ACF', 'Tailwind CSS', 'SASS/SCSS', 'JavaScript', 'PHP' ],
    sourceCode: '',
    livePreview: 'https://wiilo.fi/',
  },
  {
    name: 'Payroll.ca',
    titleColorLight: '#000000',
    titleColorDark: '#ced4e5',
    image: 'images/payrol-ca.jpg',
    description:
      'National Payroll Institute',
    stack: [ 'Bootstrap', 'SASS/SCSS', 'JavaScript', 'jQuery', 'Kentiko templating', 'Multi-language' ],
    sourceCode: '',
    livePreview: 'https://payroll.ca/',
  },
  {
    name: 'ModernCTO',
    titleColorLight: '#fcc900',
    titleColorDark: '#ffde17',
    image: 'images/moderncto.jpg',
    description:
      'Podcast website',
    stack: [ 'WordPress', 'Elementor Pro', 'JavaScript', 'jQuery', 'PHP', 'API integration' ],
    sourceCode: '',
    livePreview: 'https://moderncto.io/',
  },
  {
    name: 'Catamount Roofing',
    titleColorLight: '#4418af',
    titleColorDark: '#ba8bee',
    image: 'images/catamount.jpg',
    description:
      'Roofing company website',
    stack: [ 'WordPress', 'ACF', 'Tailwind CSS', 'SASS/SCSS', 'JavaScript', 'PHP', 'API integration' ],
    sourceCode: '',
    livePreview: 'https://catamountroofing.com/',
  },
  {
    name: 'Lehtisepät',
    titleColorLight: '#003949',
    titleColorDark: '#fff',
    image: 'images/lehtisepat.jpg',
    description:
      'Printing company website',
    stack: [ 'WordPress', 'Gutenberg', 'ACF', 'Tailwind CSS', 'SASS/SCSS', 'JavaScript', 'PHP' ],
    sourceCode: '',
    livePreview: 'https://lehtisepat.fi/',
  },
  {
    name: 'Deco North Lake Shore',
    titleColorLight: '#aa8d4d',
    titleColorDark: '#cca754',
    image: 'images/deco.jpg',
    description:
      'Real Estate website',
    stack: [ 'WordPress', 'ACF', 'Foundation', 'JavaScript', 'jQuery', 'PHP', 'API integration' ],
    sourceCode: '',
    livePreview: 'https://decolakeshoredrive.com/',
  },
  {
    name: 'Rancho Ontario',
    titleColorLight: '#00678f',
    titleColorDark: '#a5dbe0',
    image: 'images/rancho-ontario.jpg',
    description:
      'Real Estate website',
    stack: [ 'WordPress', 'ACF', 'Foundation', 'JavaScript', 'jQuery', 'PHP', 'API integration' ],
    sourceCode: '',
    livePreview: 'https://ranchoontario.com/',
  },
  {
    name: 'HCM Dialogue',
    titleColorLight: '#0077CB',
    titleColorDark: '#8ce2ff',
    image: 'images/hcmdialogue.jpg',
    description:
      'Corporate Community website',
    stack: [ 'WordPress', 'ACF', 'LiveCanvas', 'Bootstrap', 'SASS/SCSS', 'JavaScript', 'jQuery', 'PHP', 'API integration' ],
    sourceCode: '',
    livePreview: 'https://hcmdialogue.ca/',
  },
  {
    name: 'Ultimate Linings',
    titleColorLight: '#E40422',
    titleColorDark: '#ff4a62',
    image: 'images/ul.jpg',
    description:
      'Polyurea Coatings company website',
    stack: [ 'WordPress', 'Elementor Pro', 'ACF', 'JavaScript', 'jQuery', 'PHP' ],
    sourceCode: '',
    livePreview: 'https://ultimatelinings.com/',
  },
  {
    name: 'ProSeriesMedia',
    titleColorLight: '#4a5ec6',
    titleColorDark: '#FFE005',
    image: 'images/proseriesmedia.jpg',
    description:
      'Podcast Production Services',
    stack: [ 'WordPress', 'Elementor Pro', 'ACF', 'JavaScript', 'jQuery', 'PHP', 'API integration' ],
    sourceCode: '',
    livePreview: 'https://proseriesmedia.com/',
  },
]

const contact = {
  // email is optional - if left empty Contact section won't show up
  email: 'eugene.shatskih@gmail.com',
}

export { header, about, projects, skills, contact }
